export default __webpack_public_path__ + "static/media/aura.1d739d47.png";